import Component from '../abstracts/Component';

export default class CookieComponent extends Component {
  get SELECTORS() {
    return {
      main: '.js-cookie-layer',
      accept: '.js-cookie-agree'
    }
  }

  get COOKIE_INFO() {
    return {
      name: 'cookies-disclaimer-v1',
      value: true,
      options: {
        path: '/',
        value: true,
        expires: 30,
        secure: true
      }
    }
  }

  constructor() {
    super()
  }

  setCookie() {
    return new Promise((resolve, reject) => {
      try {
        const main = document.querySelector(this.SELECTORS.main);
        this.Cookies.set(this.COOKIE_INFO.name, this.COOKIE_INFO.value, this.COOKIE_INFO.options);
        main.classList.add('d-none');
        setTimeout(() => {
          main.remove();
        }, 200);
        resolve(true)
      } catch (e) {
        reject(e)
      }
    });
  }

  unbindEvents() {
    // this.$off('scroll.cookie', window);
    this.$off('click.cookie', this.SELECTORS.main);
  }

  bindEvents() {
    import( /*webpackChunkName: `js-cookie` */ "js-cookie").then((module) => {
      this.Cookies = module.default;

      // this.$on('scroll.cookie', ({event}) => {
      //   this.setCookie().then(res => {
      //     this.unbindEvents();
      //     this.$emit(this.$customEvents.COOKIE.accepted);
      //   });
      // });

      this.$on('click.cookie', () => {
        this.setCookie().then(res => {
          this.unbindEvents();
          this.$emit(this.$customEvents.COOKIE.accepted);
        });
      }, 'body', this.SELECTORS.accept);

    }).catch(error => {
      console.error("Failed to load the component", error);
    });
  }

  bindEventsIubenda() {
    if (!$('.modal-newsletter').length > 0 ) {
      import( /*webpackChunkName: `js-cookie` */ "js-cookie").then((module) => {
        this.Cookies = module.default;

        if (! this.Cookies.get('cookies-disclaimer-v1')) {
          this.setCookie().then(res => {
            this.unbindEvents();
            this.$emit(this.$customEvents.COOKIE.accepted);
          })
        }
      }).catch(error => {
        console.error("Failed to load the component", error);
      });
    }
  }

  render() {
    let thisIubenda = this;
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();

    $(window).on('load', function(){
      $('.iubenda-cs-close-btn').on('click touchstart', function(){
        thisIubenda.bindEventsIubenda();
      })
    });

    $(window).on('scroll', function(){
      thisIubenda.bindEventsIubenda();
    });
  }

}
